import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

// Individual message in a conversation
const slackMessageSchema = z.object({
  _id: zExt.objectId(),
  message: z.string(),
  messageTs: z.string(),
  permalink: z.string().optional(),
  slackUserId: z.string(),
  userEmail: z.string().optional(),
  userName: z.string().optional(),
  createdAt: z.date(),
});

// A conversation (grouped by threadTs or standalone message)
const conversationSchema = z.object({
  threadId: z.string(), // messageTs of parent (or self for non-threaded)
  channelId: z.string(),
  teamId: zExt.objectId(),
  teamName: z.string(),
  messages: z.array(slackMessageSchema), // All messages in the conversation
  firstMessageAt: z.date(),
  lastMessageAt: z.date(),
  messageCount: z.number(),
});

export const getSlackMerchantMessages = {
  name: "getSlackMerchantMessages" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
    excludeRedoEmails: z.boolean().optional(),
    hasRedoAiResponse: z.boolean().optional(),
  }),
  output: z.object({
    conversations: z.array(conversationSchema),
    allConversations: z.array(z.object({ firstMessageAt: z.date() })),
    totalCount: z.number(), // Count of unique conversations, not individual messages
  }),
};
